import * as React from "react";
import { forwardRef } from "react";
const SteeringWheelControlsIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 9.45a2.55 2.55 0 1 1 0 5.1 2.55 2.55 0 0 1 0-5.1Zm0 1.5a1.05 1.05 0 1 0 0 2.1 1.05 1.05 0 0 0 0-2.1Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 2.25c5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25Zm6.533 4.714c-6.075 2.253-10.826.713-13.11.054a8.214 8.214 0 0 0-1.631 5.815l3.007 1.183a5.793 5.793 0 0 1 3.647 4.854l.117 1.252c.466.082.946.128 1.437.128.484 0 .958-.045 1.42-.125l.09-1.166a5.793 5.793 0 0 1 3.68-4.958l3.018-1.172a8.213 8.213 0 0 0-1.675-5.865Zm-.8 8.435a4.292 4.292 0 0 0-2.727 3.674l-.049.628a8.267 8.267 0 0 0 4.877-5.118l-2.102.816Zm-13.565-.806a8.268 8.268 0 0 0 4.848 5.097l-.063-.681a4.292 4.292 0 0 0-2.703-3.597l-2.082-.82ZM12 3.75c-2.075 0-3.97.767-5.42 2.032 2.35.666 6.086 1.566 10.826-.01A8.215 8.215 0 0 0 12 3.75Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.525 8.2a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25ZM16.725 11.2a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25ZM6.425 8.2a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25ZM7.225 11.2a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z"
}));
const ForwardRef = forwardRef(SteeringWheelControlsIcon);
export default ForwardRef;